module.exports = __webpack_public_path__ + "static/img/bg23.b85ffb35.png";